import { render, staticRenderFns } from "./EventsStats.vue?vue&type=template&id=944e7e2e&scoped=true&"
import script from "./EventsStats.vue?vue&type=script&lang=js&"
export * from "./EventsStats.vue?vue&type=script&lang=js&"
import style0 from "./EventsStats.vue?vue&type=style&index=0&id=944e7e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944e7e2e",
  null
  
)

/* custom blocks */
import block0 from "./EventsStats.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports